import * as Yup from 'yup';
import {
  EFormTags,
  IFormSection,
} from '../../shared/interfaces/form-interfaces';

export const form: IFormSection[] = [
  {
    id: 'SignupCompanyForm',
    items: [
      {
        name: 'name',
        label: 'Nome do cliente',
        tag: EFormTags.textField,
      },
      {
        name: 'whatsapp',
        label: 'Whatsapp',
        tag: EFormTags.whatsapp,
      },
    ],
  },
];

export const schema = Yup.object().shape({
  name: Yup.string().required('Nome do cliente é obrigatório'),
  whatsapp: Yup.string()
    .required('Whatsapp é obrigatório')
    .length(11, '11 dígitos'),
});

export const initialData = {
  name: '',
  whatsapp: '',
};
